import React from 'react';
import '../App.css';
import HeroSection from './HeroSection';
import { Helmet } from 'react-helmet-async';

function Home() {
    return (
        <>
            <Helmet>
                <title>Projekt Sarajevska | Luksuzni stanovi u Novom Zagrebu</title>
                <meta
                    name="description"
                    content="Projekt Sarajevska – luksuzni stanovi i poslovni prostori u Novom Zagrebu, tlocrti stanova, lokacija i kontakt za prodaju."
                />
                <link rel="canonical" href="https://projekt-sarajevska.hr/" />
            </Helmet>

            <div>
                <HeroSection />
            </div>
        </>
    );
}

export default Home;